import React, { ReactElement } from "react";
import { Button, Popover } from "@mui/material";
import {Sketch, ColorResult } from '@uiw/react-color';


interface IProps {
  color: string;
  onChange: (value: string) => void;
  presetColors?: string[];
  disableAlpha?: boolean;
}

const ColorPicker = ({ color, onChange, presetColors, disableAlpha }: IProps): ReactElement => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'color-popover' : undefined;

  return (
    <div>
    <Button variant="contained" onClick={handleClick} aria-describedby={id} sx={{ background: color }}>

    </Button>
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <Sketch
        color={color}
        presetColors={presetColors}
        disableAlpha={disableAlpha}
        onChange={(color: ColorResult) => onChange(color.hex)}
      />
    </Popover>
    </div>
  );
}

export default ColorPicker;